<template>
  <div >

      <el-upload
          action=""
          :file-list="fileList"
          :http-request="getFile">

        <el-button size="small" type="primary" >文件上传</el-button>
      </el-upload>

      <el-button size="small" type="success" @click="upload">确认上传</el-button>



    <el-dialog title="返回id" :visible.sync="dialogFormVisible">


      <div slot="footer" class="dialog-footer">

        <p>文件ID:{{fileinfo.id}}</p>

        <p class="pstyle">请记住该文件id以便填写版本信息</p>
        <el-button type="primary" @click="versionhandle()">确定</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import axios from "@/wifiaxios";
import router from "@/router";

export default {
  name: "wifiapks",
  data() {
    return {
      file: {},
      fileList: [],
      fileinfo: {},
      newfileinfo: "",
      dialogFormVisible: false,
      // versioninfo:{
      //   id:"",
      //   fileId:"",
      //   versionCode:"",
      //   versionName:"",
      //   affectVersionCode:"",
      //   apkUrl:"",
      //   updateContent:"",
      //   status:"",
      //   type:"",
      //   createTime:"",
      //   createUser:"",
      //   updateTime:"",
      //   updateUser:"",
      // }


    }
  },

  created() {
    this.newfileinfo = "",
    this.dialogFormVisible = false
  },

  methods: {
    getFile(item) {
      console.log(item.file)
      this.file = item.file
    },
    upload() {
      const fd = new FormData()
      fd.append('files', this.file)
      const config = { headers: { 'Content-Type': 'multipart/form-data' }}
      axios.post('/sys/file/upload', fd
      ).then(res => {
        this.dialogFormVisible =true
        this.fileinfo = res.data.data[0]
        console.log("-------------")
        console.log(this.dialogFormVisible)
        this.newfileinfo = JSON.stringify(this.fileinfo, null, 4);
        this.$message.success(res.data.msg)
      })
    },

    cancel(){
      this.dialogFormVisible = false;
      this.$message.info("当前操作取消");
    },

    versionhandle(){
      var btndisable = false
      this.$emit("btndisable",btndisable)
      this.dialogFormVisible = false;
    }
  }



}
</script>

<style scoped>
.el-upload{
  float: left;
}

.el-button--primary{
  width: 80px;
}

.pstyle{
  color: red;
}
</style>
